import { render, staticRenderFns } from "./EventPlannerModal.vue?vue&type=template&id=2b0d912d"
import script from "./EventPlannerModal.vue?vue&type=script&lang=js"
export * from "./EventPlannerModal.vue?vue&type=script&lang=js"
import style0 from "./EventPlannerModal.vue?vue&type=style&index=0&id=2b0d912d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports